import React from 'react';

import classNames from 'classnames/bind';
import style from './EndSpreader.scss';
const ctx = classNames.bind(style);

const EndSpreader = props => (
  <div className={ctx('end-spreader')}>
    <div className={ctx('cross')}>
      <img src={'images/crossIcon.svg'} />
    </div>
  </div>
);

export default EndSpreader;
